import { render, staticRenderFns } from "./FirstSidebarItem.vue?vue&type=template&id=9880623c&scoped=true"
import script from "./FirstSidebarItem.vue?vue&type=script&lang=js"
export * from "./FirstSidebarItem.vue?vue&type=script&lang=js"
import style0 from "./FirstSidebarItem.vue?vue&type=style&index=0&id=9880623c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9880623c",
  null
  
)

export default component.exports